<h2 mat-dialog-title>Ajouter une entrée</h2>
<mat-dialog-content>
    <form [formGroup]="packageZoneForm">
        <mat-form-field class="w-full">
            <mat-label>Zone</mat-label>
            <mat-select formControlName="zone">
                @for (zone of zones; track zone.name) {
                <mat-option [value]="zone.name">{{ zone.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton [mat-dialog-close]>Annuler</button>
    <button matButton (click)="submit()">Valider</button>
</mat-dialog-actions>